import { API, Auth } from "aws-amplify";
import React from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import config from "../config.json";
import { DatePicker } from "./DatePicker";
//import './datepicker.css';
import NewsEditBase from "./NewsEditBase.js";
//import OverlayLoading from './OverlayLoading.js'
//import { he } from 'date-fns/locale';

export default function NewsEdit(props) {
  const params = useParams();
  const navigate = useNavigate();
  return <NewsEditComp {...props} navigate={navigate} params={params} />;
}

class NewsEditComp extends React.Component {
  constructor(props, params) {
    super(props);
    this.fileInput = React.createRef();
    this.state = {
      api_name: config.stage,
      loading: false,
      showDeleteButton: true,
      ref_attachment_file: React.createRef(),
      id: props.params.newsId,
      title: "",
      content: "",
      attachment: "",
      publish_date_start: "",
      publish_date_end: "",
    };
    this.editorRef = React.createRef();
  }

  componentDidMount() {
    const $editor = window.$(this.editorRef.current);
    $editor.summernote({
      height: 250,
      toolbar: [
        ["style", ["style"]],
        ["font", ["bold", "underline", "clear"]],
        ["fontname", ["fontname"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["table", ["table"]],
        ["insert", ["link"]],
        ["view", ["fullscreen", "codeview", "help"]],
      ],
      callbacks: {
        onChange: (contents) => {
          this.setState({ content: contents });
        },
      },
      lang: "ja-JP",
    });

    this.getNews();
  }

  getToken = async () => {
    return `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`;
  };

  getNews = async () => {
    this.setState({ loading: true });

    const myinit = {
      headers: {
        Authorization: await this.getToken(),
      },
    };

    await API.get(this.state.api_name, "/news/" + this.state.id, myinit)
      .then((n) => {
        this.setState({
          title: n.title,
          content: n.content,
          attachment: n.attachment,
          publish_date_start: this.getDate(n.publish_date_start),
          publish_date_end: this.getDate(n.publish_date_end),
        });

        if (this.editorRef.current) {
          window.$(this.editorRef.current).summernote("code", n.content);
        }
      })
      .catch((e) => {
        toast.error("お知らせデータの取得エラー");
      });

    this.setState({ loading: false });
  };

  getDateString = (d) => {
    return d
      ? d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
      : "";
  };

  getDate = (s) => {
    if (!s || s == "0000-00-00") {
      return null;
    } else {
      return new Date(s);
    }
  };

  putFile = async () => {
    const myinit = {
      headers: {
        Authorization: await this.getToken(),
      },
      queryStringParameters: {
        filename: this.state.ref_attachment_file.current.files[0].name,
      },
    };
    const { url, filename } = await API.get(
      this.state.api_name,
      "/news/upload_url",
      myinit
    );
    this.setState({ attachment: filename });
    const formData = new FormData();
    formData.append(filename, this.state.ref_attachment_file.current.files[0]);
    await fetch(url, { method: "PUT", body: formData });
  };

  updateNews = async () => {
    this.setState({ loading: true });

    if (this.state.ref_attachment_file.current.files[0]) {
      await this.putFile();
    }

    const news = {
      id: this.state.id,
      title: this.state.title,
      content: this.state.content,
      attachment: this.state.attachment,
      publish_date_start: this.getDateString(this.state.publish_date_start),
      publish_date_end: this.getDateString(this.state.publish_date_end),
    };

    const myinit = {
      headers: {
        Authorization: await this.getToken(),
      },
      body: news,
    };

    await API.put(this.state.api_name, "/news/" + this.state.id, myinit)
      .then((r) => {
        toast.success("お知らせを登録しました");
      })
      .catch((e) => {
        toast.error("お知らせの登録エラー");
      });

    this.setState({ loading: false });
  };

  sleep = (msec) => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve();
      }, msec);
    });
  };

  deleteNews = async () => {
    if (!window.confirm("お知らせデータを削除します。よろしいですか？")) {
      return;
    }
    this.setState({ loading: true });

    const myinit = {
      headers: {
        Authorization: await this.getToken(),
      },
    };

    await API.del(this.state.api_name, "/news/" + this.state.id, myinit)
      .then((r) => {
        toast.success("お知らせを削除しました");
        this.props.navigate("/news_edit/new");
      })
      .catch((e) => {
        toast.error("お知らせデータの削除エラー");
      });

    this.setState({ loading: false });
    //this.props.navigate("/news_list");
  };

  getFile = async () => {
    const myinit = {
      headers: {
        Authorization: await this.getToken(),
      },
    };
    await API.get(
      this.state.api_name,
      "/news/download/" + this.state.id,
      myinit
    )
      .then((r) => {
        if (r) {
          const a = document.createElement("a");
          a.href = r;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch((e) => {
        alert("データ取得エラー"); // TODO
      });
  };

  deleteFile = async () => {
    if (!window.confirm("添付ファイルを削除します。よろしいですか？")) {
      return;
    }
    this.setState({ loading: true });
    const myinit = {
      headers: {
        Authorization: await this.getToken(),
      },
    };
    await API.del(this.state.api_name, "/news/file/" + this.state.id, myinit)
      .then((r) => {
        toast.success("添付ファイルを削除しました");
        this.setState({ attachment: "" });
      })
      .catch((e) => {
        toast.error("添付ファイルの削除エラー");
      });
    this.setState({ loading: false });
  };

  render() {
    const download_attachment = [];
    if (this.state.attachment) {
      download_attachment.push(
        <button
          key="download"
          type="button"
          className="btn btn-sm btn-info"
          onClick={this.getFile}
        >
          {this.state.attachment.substring(14)}
        </button>
      );
    } else {
      download_attachment.push(
        <span key="no-download">添付ファイルはありません</span>
      );
    }
    const delete_attachment = [];
    if (this.state.attachment) {
      delete_attachment.push(
        <button
          key="delete"
          type="button"
          className="btn btn-sm btn-danger ml-2"
          onClick={this.deleteFile}
        >
          添付ファイル削除
        </button>
      );
    }

    return (
      <>
        {/* <OverlayLoading show={this.state.loading} /> */}
        <Toaster />
        <NewsEditBase
          loading={this.state.loading}
          showDeleteButton={this.state.showDeleteButton}
          onClick={this.updateNews}
          onClickDelete={this.deleteNews}
          title_input={
            <input
              type="text"
              className="form-control"
              id="title"
              placeholder="会員へのお知らせタイトル"
              value={this.state.title}
              onChange={(event) => {
                this.setState({ title: event.target.value });
              }}
            />
          }
          content_input={
            <div
              ref={this.editorRef}
              className="form-control summernote"
              id="content"
              placeholder="会員へのお知らせ本文"
              value={this.state.content}
              onChange={(event) => {
                this.setState({ content: event.target.value });
              }}
            />
          }
          file_input={
            <input type="file" ref={this.state.ref_attachment_file} />
          }
          download_attachment={download_attachment}
          delete_attachment={delete_attachment}
          publish_date_start={
            <DatePicker
              className="form-control"
              selected={this.state.publish_date_start}
              onChange={(event) => {
                this.setState({ publish_date_start: event });
              }}
              selectStart
              startDate={this.state.publish_date_start}
              endDate={this.state.publish_date_end}
            />
          }
          publish_date_end={
            <DatePicker
              className="form-control"
              selected={this.state.publish_date_end}
              onChange={(event) => {
                this.setState({ publish_date_end: event });
              }}
              selectEnd
              startDate={this.state.publish_date_start}
              endDate={this.state.publish_date_end}
              minDate={this.state.publish_date_start}
            />
          }
        />
      </>
    );
  }
}
